(function() {
  'use strict';

  /* ── Helpers ── */
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function imgUrl(url, size) {
    if (!url) return '';
    // Shopify image size transform
    return url.replace(/(\.[a-z]+)(\?|$)/, '_' + size + '$1$2');
  }

  /* ── DOM refs ── */
  var overlay  = document.getElementById('ef-drawer-overlay');
  var panel    = document.getElementById('ef-drawer-panel');
  var closeBtn = document.getElementById('ef-drawer-close');
  var itemsEl  = document.getElementById('ef-drawer-items');
  var emptyEl  = document.getElementById('ef-drawer-empty');
  var footerEl = document.getElementById('ef-drawer-footer');
  var countEl  = document.getElementById('ef-drawer-count');
  var subtotalEl = document.getElementById('ef-drawer-subtotal'); // legacy — may be null after Total-only redesign
  var totalEl  = document.getElementById('ef-drawer-total');
  var contBtn  = document.getElementById('ef-drawer-continue');

  /* ── State ── */
  var isOpen = false;
  var isUpdating = false;

  /* ── Open / Close ── */
  function open() {
    if (isOpen) return;
    isOpen = true;
    /* Start the slide-in animation FIRST so it runs smoothly. Defer the heavy
       work (cart fetch + DOM rebuild + body overflow change) until after the
       animation completes. */
    requestAnimationFrame(function() {
      overlay.classList.add('is-open');
      panel.classList.add('is-open');
      /* Toggle body class so .ef-cfg-strip + .ef-cfg-mantel-strip can hide
         when drawer is open (was staying visible orphaned at top of viewport
         while header was scrolled away). User feedback 2026-05-03. */
      document.body.classList.add('ef-cart-drawer-open');
    });
    setTimeout(function() {
      document.body.style.overflow = 'hidden';
      if (panel) panel.focus({ preventScroll: true });
      refresh();
    }, 350);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.classList.remove('ef-cart-drawer-open');
  }

  /* ── Render ── */
  function renderCart(cart) {
    var mainCount = 0;
    cart.items.forEach(function(item) {
      if (!item.properties || !item.properties['_parent_product']) mainCount += item.quantity;
    });
    countEl.textContent = mainCount;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    totalEl.textContent = formatMoney(cart.total_price);

    if (mainCount === 0) {
      itemsEl.style.display = 'none';
      emptyEl.style.display = '';
      footerEl.style.display = 'none';
      return;
    }

    itemsEl.style.display = '';
    emptyEl.style.display = 'none';
    footerEl.style.display = '';

    // Separate surcharge items from main items, keyed by _config_id
    var surchargeMap = {};
    var mainItems = [];
    cart.items.forEach(function(item) {
      var props = item.properties || {};
      if (props['_parent_product']) {
        var mapKey = props['_config_id'] || props['_parent_product'];
        if (!surchargeMap[mapKey]) surchargeMap[mapKey] = [];
        surchargeMap[mapKey].push({
          option_type: props['_option_type'] || '',
          variant_title: item.variant_title || item.product_title,
          price: item.final_price
        });
      } else {
        mainItems.push(item);
      }
    });

    /* Properties to skip in pills (shown as add-ons instead) */
    var skipProps = ['width', 'height', 'opening size', 'size category', 'configured price'];

    var html = '';
    mainItems.forEach(function(item) {
      var image = item.image || (item.featured_image && item.featured_image.url) || '';
      if (image) image = imgUrl(image, '200x200');

      /* Finish-sample thumbnail: render a color/swatch tile from line-item
         properties so cart shows the actual finish picked, not the generic
         single-variant sample-product image. When _finish_image or
         _finish_color is present (sample line item), the swatch takes
         priority over item.image. */
      var finishSwatchStyle = '';
      if (item.properties) {
        var fImg = item.properties['_Finish Image'] || item.properties['_finish_image'];
        var fHex = item.properties['_Finish Color'] || item.properties['_finish_color'];
        if (fImg && /^https?:\/\//.test(fImg)) {
          finishSwatchStyle = 'background-image:url(' + fImg.replace(/ /g, '%20') + ');background-size:cover;background-position:center;background-color:#f0e8da;';
        } else if (fHex) {
          var safeHex = fHex.replace(/[^#a-zA-Z0-9(),. %]/g, '');
          finishSwatchStyle = 'background:' + safeHex + ';';
        }
        /* Sample lines must show the finish, not the generic variant image. */
        if (finishSwatchStyle) image = '';
      }

      /* Build config pills (horizontal chips) */
      var pillsHtml = '';
      if (item.properties) {
        var pills = [];
        var keys = Object.keys(item.properties);
        keys.forEach(function(key) {
          var val = item.properties[key];
          if (!key || key.charAt(0) === '_' || !val || val === '') return;
          if (skipProps.indexOf(key.toLowerCase()) !== -1) return;
          pills.push('<span class="ef-drawer-config-pill">' + escHtml(val) + '</span>');
        });
        /* Add dimensions pill from Width + Height */
        var w = item.properties['Width'];
        var h = item.properties['Height'];
        if (w && h) pills.unshift('<span class="ef-drawer-config-pill">' + escHtml(w) + ' × ' + escHtml(h) + '</span>');
        if (pills.length > 0) {
          pillsHtml = '<div class="ef-drawer-config">' + pills.join('') + '</div>';
        }
      }

      /* Photo link */
      var photoHtml = '';
      var photoUrl = item.properties ? item.properties['_Photo URL'] : '';
      if (photoUrl) {
        photoHtml =
          '<div style="margin-top:6px;">' +
            '<a href="' + escAttr(photoUrl) + '" target="_blank" rel="noopener" ' +
              'style="display:inline-flex;align-items:center;gap:6px;font-size:11px;color:#8A6A43;text-decoration:underline;text-underline-offset:2px;">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>' +
              'View Photo' +
            '</a>' +
          '</div>';
      }

      /* Cross-sell "Personalize" deep-link — items added one-tap from "Complete Your Hearth"
         carry _cross_sell + _needs_config; let the shopper open the product to pick specs
         instead of waiting for the confirm call. */
      var personalizeHtml = '';
      if (item.properties && item.properties['_cross_sell'] && item.url) {
        personalizeHtml =
          '<div style="margin-top:6px;">' +
            '<a href="' + escAttr(item.url) + '" ' +
              'style="display:inline-flex;align-items:center;gap:6px;font-size:11px;color:#8A6A43;text-decoration:underline;text-underline-offset:2px;">' +
              '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>' +
              'Personalize — pick your specs' +
            '</a>' +
          '</div>';
      }

      /* Build surcharge add-ons — match by _config_id first, then product title */
      var addonsHtml = '';
      var cfgId = item.properties ? item.properties['_config_id'] : null;
      var itemSurcharges = surchargeMap[cfgId] || surchargeMap[item.product_title] || [];
      if (itemSurcharges.length > 0) {
        addonsHtml = '<div class="ef-drawer-addons">';
        itemSurcharges.forEach(function(s) {
          addonsHtml +=
            '<div class="ef-drawer-addon-row">' +
              '<span class="ef-drawer-addon-left">' +
                '<span class="ef-drawer-addon-dot"></span>' +
                escHtml(s.option_type) + ': ' + escHtml(s.variant_title) +
              '</span>' +
              '<span class="ef-drawer-addon-price">+' + formatMoney(s.price) + '</span>' +
            '</div>';
        });
        addonsHtml += '</div>';
      }

      html +=
        '<div class="ef-drawer-item" data-key="' + item.key + '">' +
          '<div class="ef-drawer-item-top">' +
            (image
              ? '<img class="ef-drawer-item-img" src="' + escAttr(image) + '" alt="' + escAttr(item.product_title) + '" loading="lazy">'
              : (finishSwatchStyle
                  ? '<div class="ef-drawer-item-img ef-drawer-item-img--swatch" style="' + finishSwatchStyle + '" aria-label="Finish color swatch"></div>'
                  : '<div class="ef-drawer-item-img"></div>')) +
            '<div class="ef-drawer-item-body">' +
              (item.vendor ? '<p class="ef-drawer-item-vendor">' + escHtml(item.vendor) + '</p>' : '') +
              '<p class="ef-drawer-item-title">' + escHtml(item.product_title) + '</p>' +
              /* Render variant title (e.g. '60" Width x 8" Height x 8" Depth')
                 below product title — was missing in drawer but present on full
                 cart page. Skip Shopify's default placeholder. */
              ((item.variant_title && item.variant_title !== 'Default Title')
                ? '<p class="ef-drawer-item-variant">' + escHtml(item.variant_title) + '</p>'
                : '') +
              pillsHtml +
              photoHtml +
              personalizeHtml +
            '</div>' +
          '</div>' +
          addonsHtml +
          '<div class="ef-drawer-item-footer">' +
            '<div class="ef-drawer-item-actions">' +
              '<div class="ef-drawer-qty">' +
                '<button type="button" aria-label="Decrease quantity" data-action="minus" data-key="' + item.key + '">&#8722;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" aria-label="Increase quantity" data-action="plus" data-key="' + item.key + '">+</button>' +
              '</div>' +
              '<button type="button" class="ef-drawer-remove" data-action="remove" data-key="' + item.key + '">Remove</button>' +
            '</div>' +
            '<div class="ef-drawer-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>' +
        '</div>';
    });

    itemsEl.innerHTML = html;
  }

  function escHtml(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }
  function escAttr(s) {
    return (s || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  /* ── Fetch & update ── */
  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cleanOrphans(cart);
        renderCart(cart);
        dispatchChange(cart);
      })
      .catch(function(err) {
        console.error('[EFCartDrawer] fetch error', err);
      });
  }

  /* Sync drawer state on every page load — server-rendered Liquid may be
     stale vs actual cart (browser cache, bfcache restore). */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) refresh();
  });

  function cleanOrphans(cart) {
    var parentTitles = {};
    var configIds = {};
    var parentQtyByCfg = {};
    cart.items.forEach(function(item) {
      if (!item.properties || !item.properties['_parent_product']) {
        parentTitles[item.product_title] = true;
        if (item.properties && item.properties['_config_id']) {
          configIds[item.properties['_config_id']] = true;
          parentQtyByCfg[item.properties['_config_id']] = item.quantity;
        }
      }
    });
    var orphans = {};
    cart.items.forEach(function(item) {
      if (!item.properties || !item.properties['_parent_product']) return;
      var cid = item.properties['_config_id'];
      if (cid && configIds[cid]) {
        /* 2026-07-28 heal: paid-option lines must track parent qty (legacy carts
           where qty was bumped before the cascade fix shipped). Only ever raise,
           never lower — protects any future qty-as-multiplier lines. */
        var pq = parentQtyByCfg[cid];
        if (pq > 1 && item.quantity < pq) orphans[item.key] = pq;
        return;
      }
      if (!cid && parentTitles[item.properties['_parent_product']]) return;
      orphans[item.key] = 0;
    });
    if (!Object.keys(orphans).length) return;
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: orphans })
    })
    .then(function(r) { return r.json(); })
    .then(function(updatedCart) {
      renderCart(updatedCart);
      dispatchChange(updatedCart);
    });
  }

  function changeItem(key, qty) {
    if (isUpdating) return;
    isUpdating = true;

    if (qty === 0) {
      removeWithSurcharges(key);
      return;
    }

    /* 2026-07-28: qty change cascades to the paid-option lines of the same
       _config_id (they were staying at qty 1 while the parent went to 2+). */
    fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var main = cart.items.find(function(i) { return i.key === key; });
      var cfgId = main && main.properties ? main.properties['_config_id'] : null;
      if (!main || !cfgId) {
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
      }
      var updates = {};
      updates[key] = qty;
      var oldQty = main.quantity || 1;
      cart.items.forEach(function(item) {
        if (item.key === key) return;
        if (!item.properties || !item.properties['_parent_product']) return;
        if (item.properties['_config_id'] !== cfgId) return;
        var perUnit = (oldQty > 0 && item.quantity % oldQty === 0) ? (item.quantity / oldQty) : 1;
        updates[item.key] = qty * perUnit;
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      isUpdating = false;
      renderCart(cart);
      dispatchChange(cart);
    })
    .catch(function(err) {
      isUpdating = false;
      console.error('[EFCartDrawer] change error', err);
    });
  }

  function removeWithSurcharges(key) {
    fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var mainItem = cart.items.find(function(i) { return i.key === key; });
      var configId = mainItem && mainItem.properties ? mainItem.properties['_config_id'] : null;
      var productTitle = mainItem ? mainItem.product_title : '';
      var updates = {};
      updates[key] = 0;
      cart.items.forEach(function(item) {
        if (!item.properties || !item.properties['_parent_product']) return;
        if (configId && item.properties['_config_id'] === configId) {
          updates[item.key] = 0;
        } else if (!configId && item.properties['_parent_product'] === productTitle) {
          updates[item.key] = 0;
        }
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      isUpdating = false;
      renderCart(cart);
      dispatchChange(cart);
    })
    .catch(function(err) {
      isUpdating = false;
      console.error('[EFCartDrawer] remove error', err);
    });
  }

  function dispatchChange(cart) {
    document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));
  }

  /* ── Events: quantity & remove ── */
  itemsEl.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action = btn.getAttribute('data-action');
    var key = btn.getAttribute('data-key');
    if (action === 'remove') {
      changeItem(key, 0);
    } else if (action === 'minus') {
      var span = btn.parentElement.querySelector('span');
      var current = parseInt(span.textContent, 10);
      if (current > 1) changeItem(key, current - 1);
      else changeItem(key, 0);
    } else if (action === 'plus') {
      var span = btn.parentElement.querySelector('span');
      var current = parseInt(span.textContent, 10);
      changeItem(key, current + 1);
    }
  });

  /* ── Events: close ── */
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  if (contBtn) contBtn.addEventListener('click', close);
  /* Empty-state "Continue Shopping" — closes drawer (same as X / overlay) */
  var emptyContinueBtn = document.getElementById('ef-drawer-empty-continue');
  if (emptyContinueBtn) emptyContinueBtn.addEventListener('click', close);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  /* ── Intercept cart link clicks (except "View Full Cart" inside drawer
        and except links with data-direct-checkout — those handle their own
        navigation flow, e.g. "More Payment Options" on standard PDP that
        adds to cart then redirects directly to /checkout). ── */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href="/cart"], a[href="/cart/"], [data-cart-count], .js-cart-count, [data-action="open-cart"], [aria-controls="cart-drawer"]');
    if (link && !link.closest('#ef-drawer-panel') && !link.hasAttribute('data-direct-checkout')) {
      e.preventDefault();
      e.stopPropagation();
      open();
    }
  }, true); // capture phase to beat theme handlers

  /* ── Global API ── */
  window.EFCartDrawer = {
    open: open,
    close: close,
    refresh: refresh
  };
})();
